import { getModule, Module, VuexModule, Mutation, Action } from 'vuex-module-decorators';
import { store } from '@/iti-core-vue';
import { Association } from '@/shared/dtos/association';
import { itiTokenService } from '@/iti-core-vue/services/iti-token-service';
import { ItiString, itiHttpService } from '@/iti-core-vue';
import { API } from '@/shared/api';



@Module({
    namespaced: true,
    name: 'AssociationModule',
    store,
    dynamic: true,
})

class AssociationModule extends VuexModule implements BaseModule {
    public associations: Association[] = [];

    @Mutation
    public resetState(): void {
        this.associations = [];
    }

    @Action
    public async getAssociations() {
        if (!itiTokenService.hasToken()) { return; }
        const res = await itiHttpService.get(API.association);
        this.context.commit('updateAssociations', res);
    }

    @Mutation
    public updateAssociations(items: Association[]) {
        this.associations = items;
    }

    @Action
    public async insertarAssociation(item: Association) {
        if (!itiTokenService.hasToken()) { return; }
        const res = await itiHttpService.post(API.association, item, false);
        this.context.dispatch('getAssociations');
    }

    @Action
    public async modificarAssociation(item: Association) {
        if (!itiTokenService.hasToken()) { return; }
        try {
            const res = await itiHttpService.put(API.association, item, false);
        } catch {
            // ...
        }
        this.context.dispatch('getAssociations');
    }

    @Action
    public async eliminarAssociation(id: number) {
        if (!itiTokenService.hasToken()) { return; }
        const apiDeleteAssociation = ItiString.Format(API.associationDetail, id);
        const res = await itiHttpService.delete(apiDeleteAssociation, id, false);
        this.context.dispatch('getAssociations');
    }
}

export default getModule(AssociationModule);